import { render, staticRenderFns } from "./CustomWorkAvatar.vue?vue&type=template&id=8b3e2412&"
import script from "./CustomWorkAvatar.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomWorkAvatar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports